import { AxiosRequest } from "../../../Url";
import { parseGridState } from "../../Sections/ElementsSections/SectionDocuments/DocumentsConsts";
import { defaultFieldInfo, getRightsData } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { getParamColumnsOptions, parseColumns } from "../GridTools/parseColumnTools";
import { ParamSetOption } from "../../Tools/ProjectX";

export async function clsBookGrid(grid, source, props, data) {
  source.onHandleRequest = HandleRequest(props);
  //создание стилей для сворачивающихся записей
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;

  await source.open();
  if (props.KeyField) {
    if (props.KeyField === "Code") source.setKeyFieldName(props.KeyField.toUpperCase());
    else source.setKeyFieldName(props.KeyField);
  }

  const keyFieldName = source.getKeyFieldName();
  if (!keyFieldName) source.setKeyFieldName("CODE");

  const codeField = source.fields[source.getFieldIndex("CODE")];
  //создание дефолтных полей()
  let columns = {
    title: [
      {
        fieldName: "CODE",
        title: "Код",
        width: codeField ? codeField.displayWidth * 15 : 120,
        level: 0,
        fixed: true,
        fieldInfo: { ...defaultFieldInfo, options: getParamColumnsOptions(ParamSetOption.Fixed) },
      },
      {
        fieldName: "$CheckBoxx",
        title: "Множественный выбор",
        type: "3",
        width: 21,
        level: 0,
        hide: props.MultiSel ? false : true,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: "4",
          Image: 21,
          NoTitle: true,
        },
      },
      {
        fieldName: "NAME",
        title: "Наименование",
        width: 300,
        level: 0,
        fieldInfo: { ...defaultFieldInfo },
      },
    ],
  };

  //парсинг полей запроса GetTableLayout
  if (data.json) {
    source.rights = getRightsData(data.json.Rights);
    let state;
    if (data.json.State) {
      state = data.json.State;
    }
    if (data.json.Columns && data.json.Columns.State) {
      state = data.json.Columns.State;
    }

    if (state) {
      state = parseGridState(state);
      source.setGridState(state);
    }

    columns = parseColumns(data.json, { inputColumns: columns });
    grid.setColumns(columns);
  } else grid.setColumns(columns);

  grid.MultiCLsSelect = props.MultiSel ? true : false;
  const selection = {};
  if (props.Selection) {
    const arrSelection = props.Selection.split(",");
    arrSelection.forEach((item) => {
      selection[item.match(/\d+/)[0]] = item;
    });
  }
  grid.ClsSelection = selection;

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async function (source) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
  }
  grid.setImageFields(["ID", "$CfgID"]);
  source.booksGetImage = (value, field) => {
    if (value < 0) return 3;
    if (field === "$CfgID" && value > 0 && source.getFieldTextSync("ID") > 0) return 2;
  };

  await grid.setSource(source);
  source.onRecordCollapsed = async function (event) {
    let RecordIndex;
    if (event.currentTarget !== undefined) {
      RecordIndex = event.currentTarget.getAttribute("recordindex");
    } else {
      RecordIndex = event;
    }
    let params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "RecordCollapsed")
      .set("SectionID", props.SectionID)
      .set("ObjType", props.ObjType)
      .set("RecordIndex", RecordIndex);
    await AxiosRequest(true, params);
    await grid.refreshSource("!");
    if (data.setCountRecords) data.setCountRecords(source.recordCount);
    return;
  };
  if (props.ID) {
    await grid.refreshSource(props.ID);
  } else await grid.refreshSource();
  await grid.updateGridSize();
  if (data.setCountRecords) data.setCountRecords(source.recordCount);
  if (data.setSelectedRecord) {
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
}

function HandleRequest(props) {
  return function onHandleRequest(request, loadCursor, wsm, subParams) {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID)
      .set("CanChangeActual", "1");
    wsm && params.set("WSM", "1");
    if (subParams) {
      const sParams = Object.entries(subParams);
      sParams.forEach(([key, value]) => {
        params.set(key, value);
      });
    }
    return AxiosRequest(loadCursor !== undefined ? loadCursor : true, params, request);
  };
}
